import React, { useEffect, useState } from "react";
import {
  Modal,
  Descriptions,
  Tag,
  Spin,
  message,
  Typography,
  Row,
  Col,
  Card,
  Button,
} from "antd";
import { useDispatch } from "react-redux";
import { GetWorkshopById } from "../redux/actions/WorkshopAction";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

const { Title, Text } = Typography;

dayjs.extend(utc);
dayjs.extend(timezone);

const WorkshopDetails = ({ workshopId, visible, onClose }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [workshop, setWorkshop] = useState(null);

  useEffect(() => {
    if (visible && workshopId) {
      fetchWorkshopDetails();
    }
  }, [visible, workshopId]);

  const fetchWorkshopDetails = () => {
    setLoading(true);
    
    const onSuccess = (data) => {
      setLoading(false);
      setWorkshop(data.data || data);
    };

    const onError = (error) => {
      setLoading(false);
      message.error(error, 8);
    };

    dispatch(GetWorkshopById(workshopId, onSuccess, onError));
  };

  const formatDate = (dateString) => {
    if (dateString) {
      return dayjs(dateString).format("DD/MM/YYYY");
    }
    return "-";
  };

  const formatTime = (timeString) => {
    if (timeString) {
      return timeString;
    }
    return "-";
  };

  const handleClose = () => {
    setWorkshop(null);
    onClose();
  };

  return (
    <Modal
      title={
        <Title level={4}>
          Workshop Details
        </Title>
      }
      open={visible}
      onCancel={handleClose}
      footer={[
        <Button key="close" onClick={handleClose}>
          Close
        </Button>,
      ]}
      width={800}
    >
      {loading ? (
        <div style={{ textAlign: "center", padding: "50px" }}>
          <Spin size="large" />
          <div style={{ marginTop: "16px" }}>Loading workshop details...</div>
        </div>
      ) : workshop ? (
        <div>
          <Row gutter={[16, 16]}>
            <Col span={24}>
              <Card>
                <Descriptions title="Basic Information" bordered column={2}>
                  <Descriptions.Item label="Title" span={2}>
                    <Text strong>{workshop.title}</Text>
                  </Descriptions.Item>
                  <Descriptions.Item label="Type">
                    <Tag color="blue">{workshop.type}</Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Status">
                    <Tag color={workshop.isActive ? "green" : "red"}>
                      {workshop.isActive ? "ACTIVE" : "INACTIVE"}
                    </Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Workshop Date">
                    {formatDate(workshop.workshopDate)}
                  </Descriptions.Item>
                  <Descriptions.Item label="Duration">
                    {workshop.workshopDuration}
                  </Descriptions.Item>
                  <Descriptions.Item label="Start Time">
                    {workshop.startTime ? dayjs.utc(`${workshop.workshopDate.split('T')[0]}T${workshop.startTime}`).tz("Asia/Kolkata").format("HH:mm") : "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="End Time">
                    {workshop.endTime ? dayjs.utc(`${workshop.workshopDate.split('T')[0]}T${workshop.endTime}`).tz("Asia/Kolkata").format("HH:mm") : "-"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Created At" span={2}>
                    {formatDate(workshop.createdAt)}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </Col>
          </Row>

          {workshop.description && (
            <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
              <Col span={24}>
                <Card title="Description">
                  <Text>{workshop.description}</Text>
                </Card>
              </Col>
            </Row>
          )}

          {workshop.meetingUrl && (
            <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
              <Col span={24}>
                <Card title="Additional Information">
                  <Descriptions bordered column={1}>
                    {workshop.meetingUrl && (
                      <Descriptions.Item label="Meeting URL">
                        <a href={workshop.meetingUrl} target="_blank" rel="noopener noreferrer">
                          {workshop.meetingUrl}
                        </a>
                      </Descriptions.Item>
                    )}
                  </Descriptions>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "50px" }}>
          <Text type="secondary">No workshop details available</Text>
        </div>
      )}
    </Modal>
  );
};

export default WorkshopDetails; 